import { render, staticRenderFns } from "./riskEntList.vue?vue&type=template&id=4739b9aa&scoped=true&"
import script from "./riskEntList.vue?vue&type=script&lang=ts&"
export * from "./riskEntList.vue?vue&type=script&lang=ts&"
import style0 from "./riskEntList.vue?vue&type=style&index=0&id=4739b9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4739b9aa",
  null
  
)

export default component.exports